var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useKlskDhp, useIsAuthenticated } from '../hooks';
var HomeRoute = function (_a) {
    var components = _a.components, redirectComponent = _a.redirectComponent, _b = _a.redirectPath, redirectPath = _b === void 0 ? '/' : _b, rest = __rest(_a, ["components", "redirectComponent", "redirectPath"]);
    var dhp = useKlskDhp().dhp;
    var isAuthenticated = useIsAuthenticated();
    var HomeComponent = useMemo(function () { return (dhp !== null && components[dhp] && isAuthenticated) ?
        components[dhp]
        :
            redirectComponent; }, [dhp, components, isAuthenticated, redirectComponent]);
    return (React.createElement(Route, __assign({ exact: true, key: 0 }, rest, { render: function (props) { return HomeComponent ? React.createElement(HomeComponent, __assign({}, props)) : React.createElement(Redirect, { to: redirectPath }); } })));
};
export default HomeRoute;
//# sourceMappingURL=HomeRoute.js.map